import { createHttpLink } from '@apollo/client';
import { ApplicationRoute, OriginIdentifier } from 'src/common/constants';
import { isServerSide } from '../../../../utils/validators/isServerSide';

const createAPILink = () =>
    createHttpLink({
        uri:
            !isServerSide() && window.location.origin.includes(OriginIdentifier.ZILLOW)
                ? ApplicationRoute.PREFIXED_GRAPHQL_ENDPOINT
                : ApplicationRoute.PREFIXLESS_GRAPHQL_ENDPOINT,
    });

export { createAPILink };
